import { Component, OnInit, OnDestroy, ViewChild, Input, Output, OnChanges, SimpleChange, AfterViewInit, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup }                 from '@angular/forms';
import { NgForm } from '@angular/forms';
import { SeguridadService } from '../_services/seguridad.service'
import { Subscription } from 'rxjs/Subscription';

import {GlobalEventsManager} from "../_services/globaleventsmanager.service";

import { CuestionarioService } from "../_services/cuestionario.service";

import { Nivel } from '../_models/nivel.model';
import { Pregunta } from '../_models/pregunta.model';

import { EvidenciasService } from '../_services/evidencias.service';
import { ModalDirective } from 'ng2-bootstrap/modal';

import { FileUploader, FileItem } from 'ng2-file-upload';

import { AppSettings } from '../_models/settings.models'

declare var jQuery: any;

@Component({
  selector: 'modaldocumento',
  templateUrl: 'modaldocumento.template.html'
})
export class ModalDocumentoComponent  implements OnInit, OnDestroy, OnChanges, AfterViewInit{

  @Input() _id_pregunta: any;
  @Input() _mostrarmodal: any;
  @Input() _id_cuestionario: number;
  @ViewChild('staticModalRespuestas') public staticModalRespuestas:ModalDirective;
  @Output() onChangeModal = new EventEmitter<any>();


  id_pregunta: number;
  id_cuestionario: number;
  mostrarmodal: boolean = false;

  URL = 'https://evening-anchorage-3159.herokuapp.com/api/';

  urldocumento: string = "";

  public uploader:FileUploader = new FileUploader({url: AppSettings.API_URL, autoUpload: true });


  constructor(private seguridad: SeguridadService,
              private router:Router,
              private cuestionarioService: CuestionarioService,
              private globalEventsManager: GlobalEventsManager,
              private evidenciasService: EvidenciasService,
              private ref: ChangeDetectorRef,
              private activatedRoute: ActivatedRoute){

    this.uploader.onProgressItem = (fileItem: FileItem, progress: any) => {
      this.ref.detectChanges();
    }

    this.uploader.onCompleteItem = (item:any, response:any, status:any, headers:any) => {
      //console.log("ImageUpload:uploaded:", item, response);

      let data = JSON.parse(response);
      this.urldocumento = data.response.urldocumento;



      this.cerrarModal();

    };



  }

  ngOnChanges(changes: {[ propName: string]: SimpleChange}){
    if (changes['_id_pregunta']){
      this.id_pregunta = changes['_id_pregunta'].currentValue;
    }
    if (changes['_mostrarmodal']){
      this.mostrarmodal = changes['_mostrarmodal'].currentValue;
    }
    if (changes['_id_cuestionario']){
      this.id_cuestionario = changes['_id_cuestionario'].currentValue;
    }

    let userToken : string = localStorage.getItem('currentUserToken');

    this.uploader.setOptions({
        additionalParameter: {
          id_pregunta: this.id_pregunta,
          id_cuestionario: this.id_cuestionario,
          tokenid: userToken,
          action: "CuestionariosetPreguntaDocumento",
          api_keytoken: AppSettings.API_KEYTOKEN
        }
    })
  }

  ngOnInit(){

  }

  ngOnDestroy(){

  }

  ngAfterViewInit(){
    this.abrirModal();

  }

  getListaEvidencias() {
    /*this.cuestionarioService.getListaEvidencias(this.id_cuestionario).subscribe(
        data => {
          if (data){

            this.listaevidencias = data.json().evidencias;

            setTimeout(() => this.inicializarEvidenciasSeleccionadas(), 500);
          }
        }
    );*/
  }

  abrirModal(){
    if (this.mostrarmodal){
      this.staticModalRespuestas.show();
    }
  }

  cerrarModal(){
    this.staticModalRespuestas.hide();
    this.onChangeModal.emit(this.urldocumento);
  }



}



// WEBPACK FOOTER //
// ./src/app/cuestionario/modaldocumento.component.ts